import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";
import { Cidade } from "./cidadesService";

const urlBase = `${config.urlApi}/Empresas`;  //import.meta.env.VITE_URL_API;

const urls = {
  obter: `${urlBase}`,
  obterPorId: `${urlBase}`,
  adicionar: `${urlBase}`,
  alterar: `${urlBase}`,
  excluir: `${urlBase}`,

  obterFunctionarios: `${urlBase}/ObterFuncionarios`,
  addFuncionario: `${urlBase}/AdicionarFuncionario`,
  delFuncionario: `${urlBase}/ExcluirFuncionario`,
  gerarSenhaTemp: `${urlBase}/GerarSenhaTemporaria`,
}


function getToken(): string {

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken) {
      return `Bearer  ${user.accessToken}`;
    } else {
      return "";
    }
  }
  else
    return "";
}

export const obterPorId = (id: number): Promise<Empresa> => {
  return new Promise((resolve, reject) => {

    const params = {
      id: id
    }

    console.log("obterPorId", id);
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(`${urls.obterPorId}/${id}`, { params })
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter por id")));
  });
};

export const obter = (params?: Filtros | null | any): Promise<Empresa[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obter, { params })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export async function salvar(model: Empresa): Promise<Empresa> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();

    if (model.empresaId && model.empresaId > 0) {
      return (await axios.put(`${urls.alterar}/${model.empresaId}`, model)).data
    } else {
      return (await axios.post(urls.adicionar, model)).data
    }
  } catch (error: any) {
    throw new ApiException(error || "Falha ao salvar ");
  }
}

export async function excluir(id: number): Promise<void> {
  await axios.delete(`${urls.excluir}/${id}`)
}

export async function gerarSenhaTemporaria(model: GerarSenhaTempEmpresaDto): Promise<string> {
  try {
    axios.defaults.headers.common.Authorization = getToken();
    return (await axios.post(urls.gerarSenhaTemp, model)).data
  } catch (error: any) {
    throw new ApiException(error || "Falha ao gerar senha temporária ");
  }
}



export async function adicionarFuncionario(model: EmpresaFuncDto): Promise<boolean> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();
    return (await axios.post(`${urls.addFuncionario}`, model)).data

  } catch (error: any) {
    throw new ApiException(error || "Falha ao adicionar funcionario ");
  }
}

export async function excluirFuncionario(model: EmpresaFuncDto): Promise<boolean> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();
    return (await axios.post(`${urls.delFuncionario}`, model)).data

  } catch (error: any) {
    throw new ApiException(error || "Falha ao excluir funcionario ");
  }
}


export async function obterFuncionarios(id: number): Promise<FuncionarioDto[]> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();
    return (await axios.get(`${urls.obterFunctionarios}/${id}`, { params: { id } })).data

  } catch (error: any) {
    throw new ApiException(error || "Falha ao obter funcionarios ");
  }
}




export interface Filtros {
  empresaId?: number | null;
  nome?: string | null;
  cnpj?: string | null;
  ativo?: boolean | null;
  telefone?: string | null;
  cidadeId?: number | null;
  usuarioId?: number | null;
  paginaAtual?: number | null;
  tamanhoPagina?: number | null;
}

export interface Empresa {
  empresaId?: number;
  usuarioId?: number;
  ativo?: boolean;
  nome?: string;
  responsavel?: string | null;
  cnpj?: string | null;
  ie?: string | null;
  im?: string | null;
  telefone?: string | null;
  celular?: string | null;
  logradouro?: string | null;
  numero?: string | null;
  bairro?: string | null;
  cidadeId?: number | null;
  cep?: string | null;
  complemento?: string | null;
  email?: string | null;
  senha?: string | null;
  observacoes?: string | null;
  textoContrato?: string | null;
  arquivo?: string | null;
  assinatura?: string | null;
  dataAssinatura?: string | null;
  cidade?: Cidade | null;

}

export interface GerarSenhaTempEmpresaDto {
  empresaId: number;
  minutos: number;
}

export interface EmpresaFuncDto {
  empresaId: number;
  clienteId: number;
}

export interface FuncionarioDto {
  empresaId: number;
  clienteId: number;
  nome: string;
  cpf: string;
  dataNascimento: string | null;
  celular: string;
  planoNome: string;
  valor: number;
}